<template>
  <div class="approval-container flex flex-col flex-col-jcsp">
    <div class="approval__header">
      <div class="tits flex flex-row flex-row-aic flex-row-jcsp">
        <span>入库明细</span>
        <span class="btn" @click="isEdit = !isEdit">{{ isEdit ? '完成' : '编辑' }}</span>
      </div>
      <div class="line"></div>
    </div>
    <div class="approval__content">
      <template v-for="(item, idx) in list">
        <template v-for="(goods, goodIndex) in item.apply_goods">
          <template v-for="(categor, index) in goods.goods_stock">
            <div class="item flex flex-col" :key="`${idx}-${goodIndex}-${index}`">
              <div class="item__header flex flex-row flex-row-aic flex-row-jcsp">
                <div class="title">{{ goods.goods_name }}</div>
                <!-- 删除当前分类商品 -->
                <div v-show="isEdit" class="remove">
                  <span @click="handleRemoveRow(item, goods, categor, idx, goodIndex, index)">删除</span>
                </div>
              </div>
              <div class="item__main flex flex-row flex-row-aic flex-row-jcsp">
                <span class="categor">{{ categor.name }}</span>
                <van-stepper v-if="isEdit" v-model="categor.stock" :min="1" />
                <div v-else class="count">x {{ categor.stock }}</div>
              </div>
            </div>
          </template>
        </template>
      </template>

    </div>
    <div class="btn-container">
      <div class="btn-span" @click="handleConfirmForm">确定</div>
    </div>
  </div>
</template>

<script>

import { SAVE_APPROVAL_NAME } from '@/utils/constant'
import vueBus from '@/utils/vueBus';
import { settingNavigationRight } from '@/utils/dingtalk'

export default {
  name: 'CApprovalFormSel',
  data: () => ({
    isEdit: false, // 编辑状态
    list: [],
    showEmpty: false,
    listLoading: false,
    finished: false,
    finishedText: '暂无更多数据了',
    pagination: {
      page: 1,
      page_num: 20
    },
    isSelectedAll: false,
  }),
  created() {
    this.navigationSetting()
    this.__list__()
  },
  methods: {
    // NOTE: 设置Right标题隐藏
    navigationSetting() {
      settingNavigationRight({
        show: false
      })
    },
    __list__() {
      try {
        const arrs = localStorage.getItem(SAVE_APPROVAL_NAME)

        if (arrs) {
          let list = JSON.parse(arrs)
          list = list.map(item => ({
            ...item,
            apply_goods: item.apply_goods.map(stock => ({
              ...stock,
              goods_stock: JSON.parse(stock.goods_stock)
            }))
          }))

          this.list = list
        }
      } catch (error) {
        console.log(error);
        this.$toast('请选择采购单！')
      }
    },

    // 删除行数据
    handleRemoveRow(item, goods, stock, idx, goodsIndex, index) {
      this.$dialog.confirm({
        message: `是否删除商品“${goods.goods_name}-${stock.name}”`,
        confirmButtonText: '确定',
        confirmButtonColor: 'rgba(0, 122, 255, 1)',
      }).then(() => {
        goods.goods_stock.splice(index, 1)
        this.$forceUpdate()
      })
    },

    // 确定入库明细
    handleConfirmForm() {
      this.isEdit = false
      vueBus.$emit('listenApprovalFormList', this.list)
      this.$router.go(-2)
    }
  }
}
</script>

<style lang="less" scoped>
.approval {
  &-container {
    // padding: 10px 10px 0;
    padding-top: 10px;
    height: 100vh;
    box-sizing: border-box;
  }

  &__header {
    font-size: 16px;
    padding: 14px 12px;
    background-color: #fff;

    .tits {
      padding-bottom: 16px;

      .btn {
        color: rgba(50, 144, 196, 1);
      }
    }

    span {
      margin-left: 10px;
    }

    .line {
      height: 1px;
      background-color: rgba(151, 151, 151, 0.3);

    }
  }

  &__content {
    height: 0;
    flex: 1;
    background-color: #fff;
    overflow: auto;

    .item {
      padding: 5px 10px;
      font-size: 14px;

      &:last-child {
        .item__main {
          padding-bottom: 0;
          border-bottom: initial;
        }
      }

      &__header {

        font-size: 16px;
        line-height: 38px;

        .remove {
          font-size: 14px;
          font-weight: 400;
          color: #F45642;
        }
      }

      &__main {
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(151, 151, 151, 0.2);

        .category,
        .count {
          font-size: 16px;
          font-weight: 400;
          color: #727273;
        }

        .count {
          font-size: 14px;
        }

        /deep/.van-stepper {
          border: 1px solid rgba(151, 151, 151, 1);
          border-radius: 4px;

          .van-stepper__input,
          .van-stepper__minus,
          .van-stepper__plus {
            background-color: transparent !important;
          }

          .van-stepper__minus {
            border-right: 1px solid rgba(151, 151, 151, 1);
          }

          .van-stepper__plus {
            border-left: 1px solid rgba(151, 151, 151, 1);
          }
        }


      }
    }
  }
}
</style>